import { render } from "./DriveFiles.vue?vue&type=template&id=38a98548&scoped=true&ts=true"
import script from "./DriveFiles.vue?vue&type=script&lang=ts"
export * from "./DriveFiles.vue?vue&type=script&lang=ts"

import "./DriveFiles.vue?vue&type=style&index=0&id=38a98548&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a98548"]])

export default __exports__